export default __webpack_public_path__ + "static/media/Legguards of the Black Dragon.5ce8b48a.jpg";